<template>
    <div>
    
      <div
        class="drop-area"
      >
       
        <v-card  >
          <div   class="text-center">
            <v-icon  class="text-h1">mdi-file</v-icon>
            <div v-if="editavel != arquivo.id">{{ arquivo.nome_original }}</div>
            <Lynx-Input v-else v-model="form.nome_original"></Lynx-Input>
          </div>
          <!-- Conteúdo da arquivo aqui -->
        </v-card>
        <!-- <input
          type="file"
          ref="fileInput"
          style="display: none"
          multiple
        /> -->
      </div>

      <ul>
        <li v-for="(file, index) in selectedFiles" :key="index">
          {{ file.name }} ({{ formatBytes(file.size) }})
          <span @click="removeFile(index)">Remover</span>
        </li>
      </ul>
    </div>
</template>
    
    <script>
import NotFoundData from "@/components/layouts/NotFoundData";

export default {
  components: { NotFoundData },
  data() {
    return {
      form: { nome_original: this.arquivo.nome_original  },
      selectedFiles: [],
      loading: false,
      edite:false

    };
  },
  props: 
    ['arquivo','editavel']
  ,
  computed: {
    mensagem_alert() {
      return this.$store.state.arquivo.mensagem_alert;
    },
  },

  methods: {
 
   
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileSelect(event) {
      const files = event.target.files;
      this.selectedFiles = [...this.selectedFiles, ...Array.from(files)];
    },
    handleDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      this.selectedFiles = [...this.selectedFiles, ...Array.from(files)];
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    formatBytes(bytes) {
      const kb = bytes / 1024;
      if (kb < 1024) return kb.toFixed(2) + " KB";
      const mb = kb / 1024;
      if (mb < 1024) return mb.toFixed(2) + " MB";
      const gb = mb / 1024;
      return gb.toFixed(2) + " GB";
    },
    uploadFiles() {
      // Aqui você pode implementar a lógica para enviar os arquivos para o servidor
      // Certifique-se de que o servidor está configurado para receber arquivos.
      // Você pode enviar os arquivos em um FormData.
      const formData = new FormData();
      this.selectedFiles.forEach((file,i) => {
        formData.append("files[" + i + "]", file);  
      });
        this.$store.dispatch('arquivo/uploadArquivos',{files:formData,'arquivo_id':this.arquivo.id})
      // Exemplo de como enviar os arquivos usando fetch API
      // fetch("/seu-endpoint-de-upload", {
      //   method: "POST",
      //   body: formData,
      // })
      //   .then((response) => {
      //     // Lógica de tratamento da resposta
      //   })
      //   .catch((error) => {
      //     // Lógica de tratamento de erros
      //   });

      // Limpar a lista de arquivos após o upload
      this.selectedFiles = [];
    },
  },
};
</script>
  
  <style scoped>
.drop-area {
  /* border: 2px dashed #ccc; */
  /* width: 200px; */
  text-align: center;
  cursor: pointer;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
}

span {
  cursor: pointer;
  color: red;
  margin-left: 10px;
}
</style>
    